<template>
  <div class="m-qrcode cf" v-show="!isFrozen">
    <!-- 报名图标 -->
    <div
      class="qrcode-item-container fl"
      v-if="extras.signUpIcon.display === 1"
      v-show="(signUpQrCodeState && !memberInfo.signUpId) || isSetting == 1"
      @click="showBox('signup')"
    >
      <img
        class="qrcode-item-image"
        v-if="extras.signUpIcon.display === 1"
        :src="extras && extras.signUpIcon && extras.signUpIcon.src"
        alt="立即报名"
      />
      <div class="qrcode-item" v-show="isShowBox === 'signup'">
        <div class="qrcode-close-container" @click.stop="closeBox"></div>
        <div class="qrcode-item-title text-center">手机扫码立即报名</div>
        <div class="qrcode-item-qrcode">
          <div id="j-signup"></div>
        </div>
      </div>
    </div>

    <!-- 签到码图标 -->
    <div
      class="qrcode-item-container fl"
      v-if="extras.imgQrCode.display === 1"
      v-show="memberInfo.qrCode || isSetting == 1"
      @click="showBox('qrcode')"
    >
      <img
        class="qrcode-item-image"
        v-if="extras.imgQrCode.display === 1"
        :src="extras && extras.imgQrCode && extras.imgQrCode.src"
        alt="微信"
      />
      <div class="qrcode-item" v-show="isShowBox === 'qrcode'">
        <div class="qrcode-close-container" @click.stop="closeBox"></div>
        <div class="qrcode-item-title text-center">报名成功，期待您的莅临</div>
        <div class="qrcode-item-qrcode">
          <div id="j-qrcode"></div>
        </div>
        <div class="qrcode-item-id text-center">
          参会人ID：{{ memberInfo.signUpId }}
        </div>
        <div class="qrcode-item-tips text-center">现场需要向主办方出示</div>
      </div>
    </div>
    <!-- 分享图标 -->
    <div
      v-if="extras.imgShare.display === 1"
      v-show="sharePosterUrl || isSetting == 1"
      class="qrcode-item-container fl"
      @click="showBox('share')"
    >
      <img
        class="qrcode-item-image"
        v-if="extras.imgShare.display === 1"
        :src="extras && extras.imgShare && extras.imgShare.src"
        alt="分享"
      />
      <div class="qrcode-item" v-show="isShowBox === 'share'">
        <div class="qrcode-close-container" @click.stop="closeBox"></div>
        <div class="qrcode-item-title text-center">扫码分享海报</div>
        <div class="qrcode-item-qrcode">
          <div id="j-share"></div>
        </div>
      </div>
    </div>
    <!-- 微信图标 -->
    <div
      v-if="extras.imgWeChat.display === 1"
      v-show="seminarInfo.weChatType !== 'disabled' || isSetting == 1"
      class="qrcode-item-container fl"
      @click="showBox('wechat')"
    >
      <img
        class="qrcode-item-image"
        :class="{
          'cursor-default': isSetting == 1,
        }"
        v-if="extras.imgWeChat.display === 1"
        :src="extras && extras.imgWeChat && extras.imgWeChat.src"
        alt="微信"
      />
      <div class="qrcode-item" v-show="isShowBox === 'wechat'">
        <div class="qrcode-close-container" @click.stop="closeBox"></div>
        <div class="qrcode-item-title text-center">微信扫一扫</div>
        <div class="qrcode-item-qrcode">
          <img
            class="qrcode-item-qrcode-image"
            :src="seminarInfo.weChatQrCodeUrl"
            alt=""
          />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Api from "@/service/api";
import QRCode from "qrcodejs2";
import { URLS } from "fire-wind-water/index";

export default {
  props: {
    seminarInfo: Object,
    memberInfo: Object,
    extras: Object,
    markCode: String,
    signUpStatus: Number,
    isFrozen: Boolean,
  },
  data() {
    return {
      isLogin: false,
      isSetting: 0,
      signUpQrCodeState: false,
      isShowBox: "",
      sharePosterUrl: "",
      qrcodeList: [],
    };
  },
  created() {
    if (URLS.getURL("isSetting") == 1) {
      this.isSetting = 1;
    }
  },
  watch: {
    "memberInfo.qrCode"(val) {
      if (val) {
        this.setQrcodeWithShortUrl(this.memberInfo.qrCode, "j-qrcode");
      }
    },
  },
  mounted() {
    const info = window.$sk.template.get();
    const smarketMember = info.cookie.getSession();
    this.isLogin = !!smarketMember;
    const { signUpWap, instanceId, tenantId, weChatId, schemaId } =
      this.seminarInfo;
    console.log("seminarInfo-pc:", this.seminarInfo);
    this.setQrcodeWithShortUrl(signUpWap, "j-signup").then(() => {
      if (signUpWap && this.seminarInfo.status != "completed") {
        this.signUpQrCodeState = true;
      }
    });
    if (this.memberInfo.qrCode) {
      this.setQrcodeWithShortUrl(this.memberInfo.qrCode, "j-qrcode");
    }
    if (instanceId && tenantId) {
      Api.getInstanceStatus({
        instanceId,
        tenantId,
        moduleId: 3,
        type: "poster",
      }).subscribe((instanceStatusRes) => {
        console.log("instanceStatusRes:", instanceStatusRes);
        if (
          instanceStatusRes &&
          instanceStatusRes.content &&
          instanceStatusRes.content.status &&
          instanceStatusRes.content.status === 1
        ) {
          Api.getInstanceUrl({
            instanceId,
            tenantId,
            moduleId: 3,
            type: "poster",
          }).subscribe((InstanceUrlRes) => {
            console.log("InstanceUrlRes:", InstanceUrlRes);
            if (
              InstanceUrlRes.result === 0 &&
              InstanceUrlRes.content &&
              InstanceUrlRes.content.wap
            ) {
              const { protocol } = window.location;
              const { formalUrl } = InstanceUrlRes.content.wap;
              const markCode = this.markCode || URLS.getURL("markCode");
              const markType = URLS.getURL("markType");
              const tc = URLS.getURL("tc");
              const url = `${
                protocol + formalUrl
              }index.html?tenantId=${tenantId}&moduleId=3&instanceId=${instanceId}&weChatId=${weChatId}&schemaId=${
                schemaId || 0
              }${markType ? "&markType=" + markType : ""}${
                tc ? "&tc=" + tc : ""
              }${markCode ? "&markCode=" + markCode : ""}#/`;
              this.sharePosterUrl = url;
              this.setQrcodeWithShortUrl(url, "j-share");
              console.log("url", url);
            }
          });
        }
      });
    }
  },
  methods: {
    showBox(e) {
      if (URLS.getURL("isSetting") == 1) {
        return;
      }
      this.isShowBox = e;
    },
    closeBox() {
      this.isShowBox = "";
    },
    clearSession() {
      this.sharePosterUrl = "";
    },
    setQrcode(domId, text) {
      if (this.qrcodeList.indexOf(domId) < 0) {
        this.qrcodeList.push(domId);
        new QRCode(domId, {
          width: 158,
          height: 158,
          text,
          colorDark: "#000",
          colorLight: "#fff",
        });
      }
    },
    setQrcodeWithShortUrl(url, domId) {
      return new Promise((resolve) => {
        if (!url) {
          resolve();
        } else {
          Api.getShortUrl({
            withCreate: 1,
            realUrlList: [url],
            tenantId: this.seminarInfo.tenantId,
          }).subscribe((shortUrlListRes) => {
            const shortUrl =
              window.config.shortUrl + shortUrlListRes.content[url];
            this.setQrcode(domId, shortUrl);
            resolve();
          });
        }
      });
    },
  },
};
</script>

<style lang="scss" scoped></style>
